import ReactQuill from 'react-quill';
import {
  Divider,
  FormControlLabel,
  FormHelperText,
  Switch,
  TextField,
  Typography,
} from '@mui/material';

import 'react-quill/dist/quill.snow.css';

const PrivacyPolicySection = ({
  privacyPolicyEnabled,
  setPrivacyPolicyEnabled,
  dataPrivacyPolicyUrl,
  setDataPrivacyPolicyUrl,
  dataPrivacyPolicyText,
  setDataPrivacyPolicyText,
  urlError,
  handleUrlChange,
  quillModules,
  styles,
  // Nuevas props para personalizar textos
  checkboxLabel = 'He leído las políticas de privacidad',
  setCheckboxLabel,
  acceptButtonText = 'Acepto y continuar',
  setAcceptButtonText,
  declineButtonText = 'No acepto y finalizar',
  setDeclineButtonText,
  declineMessage,
  updateDeclineMessage,
}) => {
  return (
    <div>
      <Typography
        variant="h6"
        style={{ fontWeight: 'bold', marginBottom: '15px' }}
      >
        Políticas de privacidad:
      </Typography>
      <FormControlLabel
        control={
          <Switch
            checked={privacyPolicyEnabled}
            onChange={(e) => setPrivacyPolicyEnabled(e.target.checked)}
            color="primary"
          />
        }
        label="Habilitar políticas de privacidad personalizadas"
      />
      <FormHelperText style={{ marginLeft: 0, marginBottom: '15px' }}>
        ¿Desea habilitar las políticas de privacidad?
      </FormHelperText>
      {privacyPolicyEnabled && (
        <>
          <div className={styles.input} style={{ marginBottom: '15px' }}>
            <TextField
              label="URL políticas de privacidad"
              value={dataPrivacyPolicyUrl}
              name="urlPrivacy"
              onChange={handleUrlChange}
              fullWidth
              size="small"
              error={!!urlError}
              helperText={
                urlError ||
                'Si dejas las políticas de privacidad vacías usará por defecto las de PeopleIntelligence'
              }
              placeholder="https://ejemplo.com/politicas-privacidad"
            />
          </div>
          <div className={styles.input}>
            <Typography variant="caption" color="textSecondary">
              Ingrese el texto completo de sus políticas de privacidad.
            </Typography>
            <div>
              <Typography variant="caption" color="textSecondary">
                Para ubicar el enlace de las políticas de privacidad use el
                siguiente patrón {'<<<texto link>>>'}. Si no coloca, el patrón
                en ninguna parte del texto, por defecto se mostrará el link al
                final.
              </Typography>
            </div>
            <ReactQuill
              theme="snow"
              value={dataPrivacyPolicyText}
              onChange={setDataPrivacyPolicyText}
              modules={quillModules}
              placeholder="Escriba aquí el contenido de sus políticas de privacidad..."
              style={{
                backgroundColor: '#fff',
                borderRadius: '4px',
                marginBottom: '8px',
              }}
            />
          </div>

          {/* Campos para personalizar textos */}
          <div
            className={styles.input}
            style={{ marginBottom: '15px', marginTop: '15px' }}
          >
            <TextField
              label="Texto del checkbox"
              value={checkboxLabel}
              onChange={(e) => setCheckboxLabel(e.target.value)}
              fullWidth
              size="small"
              helperText="Texto que aparecerá junto al checkbox de aceptación"
              placeholder="He leído las políticas de privacidad"
            />
          </div>

          <div className={styles.input} style={{ marginBottom: '15px' }}>
            <TextField
              label="Texto del botón de aceptar"
              value={acceptButtonText}
              onChange={(e) => setAcceptButtonText(e.target.value)}
              fullWidth
              size="small"
              helperText="Texto del botón para aceptar las políticas"
              placeholder="Acepto y continuar"
            />
          </div>

          <div className={styles.input} style={{ marginBottom: '15px' }}>
            <TextField
              label="Texto del botón de rechazar"
              value={declineButtonText}
              onChange={(e) => setDeclineButtonText(e.target.value)}
              fullWidth
              size="small"
              helperText="Texto del botón para rechazar las políticas"
              placeholder="No acepto y finalizar"
            />
          </div>
          <Divider />
          <Typography
            variant="h6"
            style={{ fontWeight: 'bold', marginBottom: '15px' }}
          >
            Configuración declinar políticas de privacidad
          </Typography>
          <div
            className={styles.input}
            style={{ marginBottom: '15px', marginTop: '15px' }}
          >
            <TextField
              label="Título para rechazar políticas"
              value={declineMessage.title}
              onChange={(e) => updateDeclineMessage('title', e.target.value)}
              fullWidth
              size="small"
              helperText="Texto que aparecerá al rechazar las políticas"
              placeholder="¿Estas seguro que de deseas rechazar las políticas?"
            />
          </div>

          <div className={styles.input} style={{ marginBottom: '15px' }}>
            <TextField
              label="Mensaje para rechazar políticas"
              value={declineMessage.message}
              onChange={(e) => updateDeclineMessage('message', e.target.value)}
              fullWidth
              size="small"
              helperText="Mensaje para rechazar las políticas"
              placeholder="Al rechazar las políticas no podrás volver a responder"
            />
          </div>

          <div className={styles.input} style={{ marginBottom: '15px' }}>
            <TextField
              label="Texto del botón de cancelar"
              value={declineMessage.buttonDeclineText}
              onChange={(e) =>
                updateDeclineMessage('buttonDeclineText', e.target.value)
              }
              fullWidth
              size="small"
              helperText="Texto del botón para cancelar y cerrar el modal"
              placeholder="Cancelar"
            />
          </div>

          <div className={styles.input} style={{ marginBottom: '15px' }}>
            <TextField
              label="Texto del botón de rechazar"
              value={declineMessage.buttonAcceptText}
              onChange={(e) =>
                updateDeclineMessage('buttonAcceptText', e.target.value)
              }
              fullWidth
              size="small"
              helperText="Texto del botón para rechazar las políticas"
              placeholder="Si, rechazar"
            />
          </div>
        </>
      )}
    </div>
  );
};

export default PrivacyPolicySection;
